<button
  *ngIf="!hidden"
  type="button"
  class="nova-launcher"
  (click)="openNova()"
  aria-label="Ask me anything">
  <span class="nova-launcher-title">Ask me anything!</span>
  <span class="nova-launcher-icon" aria-hidden="true">
    <img src="assets/icons/navigator/nova-icon.svg" alt="">
  </span>
</button>
